import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { ErrorPage } from '../../components/ErrorPage/ErrorPage';
import { useAuth } from '../../hooks/useAuth';
import { AuthLayout } from '../AuthLayout';

export const ForceSignout: React.FC = () => {

  const auth = useAuth();
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    auth &&
      auth.logout()
        .catch((err) => {
          setError(err.message);
        });
  }, []);

  if (error) return <ErrorPage title={"Error"}  message={error} link={{ label: "Sign In", url: "/login" }} />

  return (
    <AuthLayout title="Signing out">
      {/* The spinner alone. The page is already titled "Signing out", and
          repeating it under the spinner said the same thing twice. */}
      <div className="flex justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-primary" aria-label="Signing out" />
      </div>
    </AuthLayout>
  );
}
